import clock from '@/lib/clock';
import hash from '@/lib/helpers/hash';
import obfuscate from '@/lib/helpers/obfuscate';
import unobfuscate from '@/lib/helpers/unobfuscate';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';

export default {
    data: () => ({
        /**
         * @type {String} - The key to localStorage
         */
        storeKey: null,
        /**
         * @type {Boolean} - Should the data be obfuscated?
         */
        storeObfuscate: true
    }),
    mounted() {
        if (!this.storeKey) {
            this.storeKey = hash(`${this.$route.name}-${this.$options.name}`);
        }
    },
    methods: {
        /**
         * Get the store value
         * Returns the unobfuscated localStorage value for the store
         *
         * @returns {Array}
         */
        getStore() {
            let store = localStorage.getItem(this.storeKey);

            if (store) {
                if (this.storeObfuscate) {
                    store = unobfuscate(store);
                } else {
                    store = JSON.parse(store);
                }

                return sortBy(store, 'createdAt').reverse();
            }

            return [];
        },
        /**
         * Set the store value
         * Overwrites the localStorage value for the store
         *
         * @param {Object} store - The store to save to localStorage
         */
        setStore(store) {
            if (this.storeObfuscate) {
                store = obfuscate(store);
            } else {
                store = JSON.stringify(store);
            }
            localStorage.setItem(this.storeKey, store);
        },
        /**
         * Returns the localStorage value for the store with the given label
         *
         * @param {String} label - The label of the items in the store
         * @returns {Array} - The store items with the given label
         */
        getStoreItems(label) {
            let store = this.getStore();

            if (store) {
                return filter(store, { label: label });
            }

            return [];
        },
        /**
         * Save the data to the store with the given label
         *
         * @param {Object} data - The data to save to localStorage
         * @param {String} label - The label of the items in the store
         * @param {Number} max - The maximum number of items to save per label
         */
        setStoreItem(data, label, max = 10) {
            let store = this.getStore();

            store = store.filter((item, index) => {
                if (item.label === label) return false;
                return index < max - 1;
            });

            const item = { createdAt: clock().unix(), label, data, hash: hash(data) };

            store.push(item);

            this.setStore(store);

            return item.hash;
        }
    }
};
